module.exports = __webpack_public_path__ + "static/media/00_internal_database_tool_card.c2ca9c34.png";